import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vue__slide-show" }


export default /*#__PURE__*/_defineComponent({
  __name: 'slide-show',
  props: {
    slideshowId: {
      type: Number,
      default: null,
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})